import React from 'react';
import Button, { buttonClasses } from './base';
import LoadingButton from './LoadingButton';
import CloseButton from './CloseButton';

const PrimaryButton = props => <Button variant="primary" {...props} />;

const AltPrimaryButton = props => <Button variant="altPrimary" {...props} />;

const SecondaryButton = ({ noBorder, ...props }) => (
  <Button variant="secondary" noBorder={noBorder} {...props} />
);

const AltSecondaryButton = ({ noBorder, ...props }) => (
  <Button variant="altSecondary" noBorder={noBorder} {...props} />
);

const AltTertiaryButton = ({ noBorder, ...props }) => (
  <Button variant="altTertiary" noBorder={noBorder} {...props} />
);

const TertiaryButton = props => <Button variant="tertiary" {...props} />;

const ConfirmButton = props => <Button variant="confirm" {...props} />;

const CancelButton = props => <Button variant="cancel" {...props} />;

const TextButton = props => <Button variant="text" {...props} />;

const BUTTON_CLASSES = {
  primary: buttonClasses({ variant: 'primary' }),
  secondary: buttonClasses({ variant: 'secondary' }),
  tertiary: buttonClasses({ variant: 'tertiary' }),
  altPrimary: buttonClasses({ variant: 'altPrimary' }),
  altSecondary: buttonClasses({ variant: 'altSecondary' }),
  primaryRect: buttonClasses({ variant: 'primary', rect: true })
};

export {
  PrimaryButton,
  SecondaryButton,
  TertiaryButton,
  AltPrimaryButton,
  AltSecondaryButton,
  AltTertiaryButton,
  LoadingButton,
  ConfirmButton,
  CancelButton,
  TextButton,
  CloseButton,
  BUTTON_CLASSES
};
